export const PRIORITY_FIELD = 'priority';
export const EMPTY_STRING = '';
export const DASH = '-';

// format constants
export const TWO_DECIMALS_FORMAT = '.2-2';

export const defaultTxt = DASH;
